<div class="langDropdown flex flex-column" [ngClass]="{ absolute: position() === 'absolute' }">
  <span class="mb-1">{{ "common.language" | translate }}</span>
  <p-select [options]="langs" [(ngModel)]="currentLang" (onChange)="changeLanguage($event)" class="w-full" size="small">
    <ng-template let-lang #selectedItem>
      {{ lang.label | translate }}
    </ng-template>
    <ng-template let-lang #item>
      {{ lang.label | translate }}
    </ng-template>
  </p-select>
</div>
